import React from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import { useForm } from './hooks/useForm';

function VerifyMobileNumber() {
  const [values,handleChange] = useForm({country_code: '', phone: ''});

  const handleSubmit = e => {
    e.preventDefault();

    axios.post(`http://127.0.0.1:8000/api/verify`, values)
      .then(res => {
        console.log(res);
        console.log(res.data);
      })
  }

  return (
    <div className="main-container form-bg-color">
    <img src={logo} className="form-logo" alt="logo" />
    <div className="form-container2">
        <div className="form-label-vm2">Verify Mobile Number</div>
        <div className="form-label2-vmn2">Please enter your phone number</div>
        <span className="text-vmn2">You will receive a text message with <br/> your verification code.</span>

        <form className="form-container-inner2" onSubmit={handleSubmit}>
            <select id="country_code" name="country_code" className="form-select-country-code" value={values.country_code} onChange={handleChange}>
                <option value="01">+01</option>
                <option value="63">+63</option>
                <option value="93">+93</option>
                <option value="+61">+61</option>
            </select>
            <input className="form-input-vmn" min="1" max="10" type="text" id="phone" name="phone" placeholder="" value={values.phone} onChange={handleChange} required/>
            <hr/>
            <button type="submit" className="btn-send-code">SEND CODE</button>

        </form>        
      </div>
        <span ><Link to="/verification" className="btn-back-vmn"> 🡠 Back </Link> </span>      
    </div>
  );
}

export default VerifyMobileNumber;
